import React from "react";
import ReactEcharts from "echarts-for-react"; 
function GraphDifference({myData2020, myData2,annee, dataGraph2020SimFerme, print, degre, labelReference = '2020', couleurReference = 'green', couleurHorizon = 'red'}) { 
  const updateData = () => {
    if (myData2020[0] < 0 && myData2020[0] < myData2[0]) {
      const diff = myData2[0] - myData2020[0];
      myData2020[0] = 1;
      myData2[0] = 1 + diff;
    } else if (myData2[0] < 0 && myData2020[0] > myData2[0]) {
      const diff = myData2020[0] - myData2[0];
      myData2[0] = 1;
      myData2020[0] = 1 + diff;
    }
  };
  updateData();
    const getOptions = () => {
      let options = {
        xAxis: {
            type: 'category',
            data: ['Très courant', 'Courant', 'Exceptionnel', 'Catastrophique'],
            name: 'Risques',
            nameLocation: 'middle', // Place le nom au centre sous l'axe
            nameGap: 30, // Ajustez la distance entre le nom et l'axe X
            nameTextStyle: {
              fontSize: 16 // Ajustez la taille de la police selon vos besoins
            },
            axisLabel: {
              fontSize: 14, // Ajustez la taille de la police des valeurs de l'axe Y selon vos besoins
              interval: 0 // Forcer l'affichage de toutes les étiquettes de l'axe x // Ajustez la taille de la police des valeurs de l'axe Y selon vos besoins
            }
          },
          legend : {
            data:[labelReference, annee],
            top:0,
            textStyle: {
              fontSize: 20 // Ajustez la taille de la police de la légende selon vos besoins
            }
          },
          yAxis: {
            type: 'value',
            name: 'Pertes en %',
            nameTextStyle: {
              fontSize: 16 // Ajustez la taille de la police selon vos besoins
            },
            axisLabel: {
              fontSize: 16 // Ajustez la taille de la police des valeurs de l'axe Y selon vos besoins
            }
          },
          series: [
            {
              name: labelReference,
              data: myData2020,
              type: 'line',
              smooth: true,
              symbol: 'circle',
              symbolSize: 10,
              lineStyle: {
                width: 3, // Ajustez la largeur de la ligne selon vos besoins
              },
              itemStyle: {
                color: couleurReference,
              },
              emphasis: {
                focus: 'series',
                label: {
                  show: true,
                  formatter: function (param) {
                    return (param.data).toFixed(2) + " %" ;
                  },
                  position:'top',
                  textStyle: {
                    fontSize: 14 // Ajustez la taille de police selon vos préférences
                  },
                },
              },
            },
            {
                name: annee,
                data: myData2,
                type: 'line',
                smooth: true,
                symbol: 'circle',
                symbolSize: 10,
                lineStyle: {
                    width: 3, // Ajustez la largeur de la ligne selon vos besoins
                  },
                  itemStyle: {
                    color: couleurHorizon,
                  },
                  emphasis: {
                    focus: 'series',
                    label: {
                      show: true,
                      formatter: function (param) {
                        return (param.data).toFixed(2) + " %" ;
                      },
                      position:'top',
                      textStyle: {
                        fontSize: 14 // Ajustez la taille de police selon vos préférences
                      },
                    },
                  },
              },
              {
                name: '2020SimFerme',
                data: dataGraph2020SimFerme,
                type: 'line',
                smooth: true,
                symbol: 'circle',
                symbolSize: 10,
                lineStyle: {
                  width: 3, // Ajustez la largeur de la ligne selon vos besoins
                },
                itemStyle: {
                  color: 'blue',
                },
                emphasis: {
                  focus: 'series',
                  label: {
                    show: true,
                    formatter: function (param) {
                      return (param.data).toFixed(2) + " %" ;
                    },
                    position:'top',
                    textStyle: {
                      fontSize: 14 // Ajustez la taille de police selon vos préférences
                    },
                  },
                },
              },
          ]
      };
  
      return options;
    };
  

    return (
      <div style={{marginBottom: print === true ? "0px" : "20px", width: print === true ? '920px' : '100%', height: '450px'}}>
        <ReactEcharts option={getOptions()} style={{ height: '100%', width:'100%' }} />
    </div>
  
  );
}

export default GraphDifference;
  